import { userConstants } from '../utils/types';

export default function authentication(state = {}, action) {
  switch (action.type) {
  case userConstants.LOGIN_REQUEST:
    return {
      loggingIn: true,
      user: action.payload.user
    };
  case userConstants.LOGIN_SUCCESS:
    return {
      loggedIn: true,
      user: action.payload.user
    };
  case userConstants.LOGIN_FAILURE:
    return { ...state, error: action.payload.error };
  case userConstants.LOGOUT:
    return {};
  case userConstants.UPDATE_USER:
    return {
      ...state,
      user: {
        ...state.user,
        ...action.payload.params
      }
    };
  case userConstants.UPDATE_UTM:
    return {
      ...state,
      utm: {
        ...action.payload.params
      }
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js